module.exports = __webpack_public_path__ + "static/img/template2.fa28c593.png";